import {
  categories as alertSeverity,
  initialKnownIssues,
} from '../../../Alerts/constants';
import { AlertCategories, TextFilterCategory } from './types';

export const textFilterCategories: TextFilterCategory[] = [
  {
    id: 'serial_number',
    label: 'Serial Number',
  },
  {
    id: 'imei',
    label: 'IMEI',
  },
  {
    id: 'MAC',
    label: 'MAC',
  },
];

export type Descriptions = {
  [key: string]: string;
};

export const statusDescriptions: Descriptions = {
  '902': 'Hostname does not resolve to an allowed IP address',
  '906': 'Webhook blocked',
  '953': 'SSL Certificate Error',
  '903': 'Host not found',
  '913': 'Authentication fail',
  '915': 'Unsupported device and/or measurement type',
  '905': 'Endpoint does not have a valid HTTPS certificate',
  '100': 'Continue',
  '101': 'Switching Protocols',
  '102': 'Processing',
  '103': 'Early Hints',
  '200': 'OK',
  '201': 'Created',
  '202': 'Accepted',
  '203': 'Non-Authoritative Information',
  '204': 'No Content',
  '205': 'Reset Content',
  '206': 'Partial Content',
  '207': 'Multi-Status',
  '208': 'Already Reported',
  '226': 'IM Used',
  '300': 'Multiple Choices',
  '301': 'Moved Permanently',
  '302': 'Found',
  '303': 'See Other',
  '304': 'Not Modified',
  '305': 'Use Proxy',
  '307': 'Temporary Redirect',
  '308': 'Permanent Redirect',
  '400': 'Bad Request',
  '401': 'Unauthorized',
  '402': 'Payment Required',
  '403': 'Forbidden',
  '404': 'Not Found',
  '405': 'Method Not Allowed',
  '406': 'Not Acceptable',
  '407': 'Proxy Authentication Required',
  '408': 'Request Timeout',
  '409': 'Conflict',
  '410': 'Gone',
  '411': 'Length Required',
  '412': 'Precondition Failed',
  '413': 'Payload Too Large',
  '414': 'URI Too Long',
  '415': 'Unsupported Media Type',
  '416': 'Range Not Satisfiable',
  '417': 'Expectation Failed',
  '418': "I'm a Teapot",
  '421': 'Misdirected Request',
  '422': 'Unprocessable Entity',
  '423': 'Locked',
  '424': 'Failed Dependency',
  '425': 'Too Early',
  '426': 'Upgrade Required',
  '428': 'Precondition Required',
  '429': 'Too Many Requests',
  '431': 'Request Header Fields Too Large',
  '451': 'Unavailable For Legal Reasons',
  '500': 'Internal Server Error',
  '501': 'Not Implemented',
  '502': 'Bad Gateway',
  '503': 'Service Unavailable',
  '504': 'Gateway Timeout',
  '505': 'HTTP Version Not Supported',
  '506': 'Variant Also Negotiates',
  '507': 'Insufficient Storage',
  '508': 'Loop Detected',
  '509': 'Bandwidth Limit Exceeded',
  '510': 'Not Extended',
  '511': 'Network Authentication Required',
};

export const alertsCategories: AlertCategories = {
  isBehindSyncingSchedule: {
    label: initialKnownIssues.isBehindSyncingSchedule.label,
    queryKey: 'to_next_communication_at',
    queryValue:
      initialKnownIssues.isBehindSyncingSchedule.queryValue ||
      encodeURIComponent(new Date().toISOString()),
  },
  hasLowBattery: {
    label: initialKnownIssues.hasLowBattery.label,
    queryKey: 'battery_voltage_health',
    queryValue: alertSeverity.WARNING.value,
  },
  hasMinBattery: {
    label: initialKnownIssues.hasMinBattery.label,
    queryKey: 'battery_voltage_health',
    queryValue: alertSeverity.CRITICAL.value,
  },
  hasLowSignalStrength: {
    label: initialKnownIssues.hasLowSignalStrength.label,
    queryKey: 'signal_strength_health',
    queryValue: alertSeverity.WARNING.value,
  },
  hasMinSignalStrength: {
    label: initialKnownIssues.hasMinSignalStrength.label,
    queryKey: 'signal_strength_health',
    queryValue: alertSeverity.CRITICAL.value,
  },
  hasNoTargetSystem: {
    label: initialKnownIssues.hasNoTargetSystem.label,
    queryKey: 'noTarget',
    queryValue: 'true',
  },
  hasPendingChanges: {
    label: initialKnownIssues.hasPendingChanges.label,
    queryKey: 'pendingChange',
    queryValue: 'true',
  },
  hasAvgLowBattery: {
    label: initialKnownIssues.hasAvgLowBattery.label,
    queryKey: 'battery_voltage_average_health',
    queryValue: alertSeverity.WARNING.value,
  },
  hasAvgMinBattery: {
    label: initialKnownIssues.hasAvgMinBattery.label,
    queryKey: 'battery_voltage_average_health',
    queryValue: alertSeverity.CRITICAL.value,
  },
  hasAvgLowSignalStrength: {
    label: initialKnownIssues.hasAvgLowSignalStrength.label,
    queryKey: 'signal_strength_average_health',
    queryValue: alertSeverity.WARNING.value,
  },
  hasAvgMinSignalStrength: {
    label: initialKnownIssues.hasAvgMinSignalStrength.label,
    queryKey: 'signal_strength_average_health',
    queryValue: alertSeverity.CRITICAL.value,
  },
};
